import * as React from 'react';
import { List } from '../../components/List';
import { useDispatch, useSelector } from 'react-redux';
import { selectCanLoadMore, selectFolders, selectSavedOfferId, selectSelectedIds } from '../../selectors';
import { selectFolder, unselectFolder } from '../../actions';
import { getFoldersForOffer } from '../../thunks';
import { jsx as _jsx } from "react/jsx-runtime";
export function ListContainer() {
  var dispatch = useDispatch();
  var folders = useSelector(selectFolders);
  var canLoadMore = useSelector(selectCanLoadMore);
  var selectedIds = useSelector(selectSelectedIds);
  var offerIds = useSelector(selectSavedOfferId);
  var offerId = offerIds.length ? offerIds[0] : 0;
  var handleChangeFolder = function handleChangeFolder(folderId, checked) {
    dispatch((checked ? selectFolder : unselectFolder)({
      folderId: folderId
    }));
  };
  var handleLoadMoreClick = function handleLoadMoreClick() {
    dispatch(getFoldersForOffer({
      offerId: offerId,
      offset: folders.length,
      keepExisting: true
    }));
  };
  if (!folders.length) {
    return /*#__PURE__*/_jsx("div", {
      children: "\u041D\u0435\u0442 \u043F\u043E\u0434\u0431\u043E\u0440\u043E\u043A"
    });
  }
  return /*#__PURE__*/_jsx(List, {
    folders: folders,
    selectedIds: selectedIds,
    onChangeFolder: handleChangeFolder,
    showLoadMoreButton: canLoadMore,
    onLoadMoreButtonClick: handleLoadMoreClick
  });
}